import React from "react";

export default function MonthlyCharges(props) {
  const info = props.info;

  return (
    <div
      className="AnaliseTable-container"
      style={{ justifyContent: "flex-start" }}
    >
      <div
        className="consume-header"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <p className="consume-title-analise">Encargos mensais</p>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          fontSize: "14px",
          marginTop: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "0px 20px",
            fontSize: "14px",
          }}
        >
          <p
            style={{
              textAlign: "center",
              width: "50%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            Energia de reserva
          </p>
          <p
            style={{
              textAlign: "center",
              width: "50%",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            R${" "}
            {(info.energyReserveTax && !isNaN(info.energyReserveTax)
              ? parseFloat(info.energyReserveTax)
              : 0.0
            ).toLocaleString("pt-BR", {
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "0px 20px",
            fontSize: "14px",
          }}
        >
          <p
            style={{
              textAlign: "center",
              width: "50%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            Garantia financeira
          </p>
          <p
            style={{
              textAlign: "center",
              width: "50%",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            R${" "}
            {(info.financialGuaranteeTax && !isNaN(info.financialGuaranteeTax)
              ? parseFloat(info.financialGuaranteeTax)
              : 0.0
            ).toLocaleString("pt-BR", {
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "0px 20px",
            fontSize: "14px",
          }}
        >
          <p
            style={{
              textAlign: "center",
              width: "50%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            Reserva de capacidade
          </p>
          <p
            style={{
              textAlign: "center",
              width: "50%",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            R${" "}
            {(info.capacityReserveTax && !isNaN(info.capacityReserveTax)
              ? parseFloat(info.capacityReserveTax)
              : 0.0
            ).toLocaleString("pt-BR", {
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "0px 20px",
            fontSize: "14px",
          }}
        >
          <p
            style={{
              textAlign: "center",
              width: "50%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            Cota nuclear
          </p>
          <p
            style={{
              textAlign: "center",
              width: "50%",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            R${" "}
            {(info.quotaNuclearTax && !isNaN(info.quotaNuclearTax)
              ? parseFloat(info.quotaNuclearTax)
              : 0.0
            ).toLocaleString("pt-BR", {
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "0px 20px",
            fontSize: "14px",
          }}
        >
          <p
            style={{
              textAlign: "center",
              width: "50%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            Boleto associativo
          </p>
          <p
            style={{
              textAlign: "center",
              width: "50%",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            R${" "}
            {(info.associativeContributionTax &&
            !isNaN(info.associativeContributionTax)
              ? parseFloat(info.associativeContributionTax)
              : 0.0
            ).toLocaleString("pt-BR", {
              style: "decimal",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </p>
        </div>
      </div>
    </div>
  );
}
